import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installErrorLogger } from "@/lib/errorLog";
import { hydrateSessionToken } from "@/lib/sessionStore";
import i18n, { hydrateLanguage } from "@/i18n";

installErrorLogger();

// Hydrate the session token from native Preferences BEFORE the first React
// render. Otherwise AuthContext.refresh() fires with a null token and routes
// the user to /login even when they already authenticated last session.
Promise.all([hydrateSessionToken(), hydrateLanguage()]).finally(() => {
  // Touch i18n so tree-shaking doesn't drop it
  void i18n.language;
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
